import {
  Box,
  Button,
  CardActions,
  CardContent,
  CircularProgress,
  Grid,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  styled,
  Switch,
  useTheme,
  FormControlLabel,
  IconButton,
  Typography,
  Tooltip,
  // Checkbox,
  InputLabel,
  Chip,
  FormControl
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import MainCard from 'components/MainCard';
import * as Yup from 'yup';
import { InfoCircle } from 'iconsax-react';
import useApi from 'hooks/useApi';
import useSelection from 'hooks/useSelection';
import ErrorTooltip from 'components/ErrorTooltip';
import { PERMISSIONS } from 'contexts/PermissionContext';
import { useHasPermission } from 'contexts/PermissionContext';
import { PermissionWrapper } from 'components/PermissionComponents';



const SGrid = styled(Grid)({ display: 'flex', textAlign: 'right', alignItems: 'center', justifyContent: 'end' });

const defaultValue: {
  name: string;
  description: string;
  client: string;
  default: boolean;
  settings: {
    addTransaction: boolean;
    addTransactionAtDriver: boolean;
    allowThirdPartyTransaction: boolean;
    transactionLabel: string;
    dueDateLabel: string;
    startDateLabel: string;
    isMfaEnabled: boolean;
    mfaKey: string | null;
    
  };
  transactionFieldSelect: any;
  reportingStatus: boolean;
  displayStepStatus:boolean;
  process:boolean;
} = {
  name: '',
  description: '',
  client: '',
  default: false,
  settings: {
    addTransaction: false,
    addTransactionAtDriver: false,
    allowThirdPartyTransaction: false,
    transactionLabel: '',
    dueDateLabel: '',
    startDateLabel: '',
    isMfaEnabled: false,
    mfaKey: null,
  },
  transactionFieldSelect: [],
  reportingStatus: false,
  displayStepStatus: false,
  process: false
};
// type TeamFormValues = typeof defaultValue;

const TeamForm = ({ selected, resetForm, teamUid }: any) => {
  const theme = useTheme();
  const [clients, setClients] = useState<any[]>([]);
  const { createTeam, showToast, getFlowByTeamUid, updateTeam, getClientsList } = useApi();
  const { clientOptions } = useSelection();
  const [initialValues, setInitialValues] = useState<typeof defaultValue | null>(null);
  
  // Use clientOptions from context if available, otherwise use local clients state
  const availableClients = clientOptions.length > 0 ? clientOptions : clients;
  // Helper to get preselected authkey fields
  const getAuthkeyFields = (fieldsArr:any) => {
    if (!Array.isArray(fieldsArr)) return [];
    let selectedFields: any[] = [];
    fieldsArr.forEach((step) => {
      const allFields = step.component?.fields || [];
      allFields.forEach((field: any) => {
        if (field.settings?.isAuthkey) {
          selectedFields.push(JSON.stringify({ question: field.question, uid: field.uid }));
        }
      });
    });
    return selectedFields;
  };
  const [processFields, setProcessFields] = useState<any[]>([]);
  // Permission check
  const hasEditPermission = useHasPermission(PERMISSIONS.ADD_EDIT_PROCESS);

  // Generate weblink URL from current subdomain
  const getWeblinkUrl = () => {
    const currentHost = window.location.hostname;
    // Extract subdomain (everything before the first dot)
    const subdomain = currentHost.split('.')[0];
    
    // Check for localhost
    if (subdomain === 'localhost') {
      return `http://localhost:8000/?team=${teamUid}`;
    }
    
    // Check for development environment
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      return `https://${subdomain}.weblink.quikstep.io/?team=${teamUid}`;
    }

    if (process.env.REACT_APP_ENVIRONMENT === 'production') {
      return `https://${subdomain}.weblink.quikstep.co/?team=${teamUid}`;
    }

    // Default fallback for no subdomain
    if (!subdomain) {
      return `https://weblink.quikstep.co/?team=${teamUid}`;
    }
    
    return `https://weblink.quikstep.co/?team=${teamUid}`;
  };



  useEffect(() => {
    loadClients();
  }, []);

  useEffect(() => {
    if (selected && teamUid) {
      let {
        name,
        description,
        client,
        default: isDefault,
        settings,
        transactionFieldSelect,
        reportingStatus,
        displayStepStatus,
        process
      } = selected;
      // Preselect authkey fields if not already present
      let preselectedFields = [];
      if (Array.isArray(processFields) && processFields.length > 0) {
        preselectedFields = getAuthkeyFields(processFields);
      }
      let selectedFields = Array.isArray(transactionFieldSelect)
        ? transactionFieldSelect.map((field) => JSON.stringify(field))
        : defaultValue.transactionFieldSelect;
      // Merge and deduplicate
      selectedFields = Array.from(new Set([...selectedFields, ...preselectedFields]));
      setInitialValues({
        name,
        description,
        client: client?.uid ? client?.uid : '',
        default: isDefault,
        settings: settings || defaultValue.settings,
        transactionFieldSelect: selectedFields,
        reportingStatus: reportingStatus || false,
        displayStepStatus: displayStepStatus || false,
        process: process || false
      });
    } else {
      // If creating new, preselect authkey fields
      let preselectedFields = [];
      if (Array.isArray(processFields) && processFields.length > 0) {
        preselectedFields = getAuthkeyFields(processFields);
      }
      setInitialValues({
        ...defaultValue,
        transactionFieldSelect: preselectedFields
      });
    }
    loadClients();
  }, [selected, teamUid, processFields]);

  const loadClients = async () => {
    // Only load clients if not available from context
    if (clientOptions.length === 0) {
      let clientsResp = await getClientsList();
      let { success, data } = clientsResp;
      if (success) {
        setClients(data);
      }
    }
  };
  

  useEffect(() => {
     
      fetchSteps();
    }, [teamUid]);
  
  
     async function fetchSteps() {
        if (!teamUid) return;
        try {
          const resp = await getFlowByTeamUid(teamUid);
          if (resp?.data?.steps) {
            setProcessFields(resp?.data?.steps)
           
          }
        } catch {
          // setStepOptions([]);
          // setProcessFields([]);
        }
      }
  

  const onTeamFormSubmit = (formData: any, setSubmitting: any) => {
  let transactionFieldSelect = formData.transactionFieldSelect;
if (Array.isArray(transactionFieldSelect)) {
  transactionFieldSelect = transactionFieldSelect.map((item: any) =>
    typeof item === "string" ? JSON.parse(item) : item
  );
}
    const payload = { ...formData, transactionFieldSelect };
    if (teamUid) {
      updateTeamApi(payload, setSubmitting);
    } else {
      createTeamApi(payload, setSubmitting);
    }
  };

  const createTeamApi = async (payload: any, setSubmitting: any) => {
    try {
      delete payload.default;
      const response = await createTeam(payload);
      const { success, message } = response;
      if (success) {
        showToast(`Team has been created`, 'success');
        resetForm();
      } else {
        showToast(message, 'error');
      }
      setSubmitting(false);
    } catch (error: any) {
      showToast(error.message, 'error');
      setSubmitting(false);
    }
  };

  const updateTeamApi = async (payload: any, setSubmitting: any) => {
    try {
      delete payload.client;
      const response = await updateTeam(payload, teamUid);
      const { success, message } = response;
      if (success) {
        showToast(`Team has been updated`, 'success');
        resetForm();
      } else {
        showToast(message, 'error');
      }
      setSubmitting(false);
    } catch (error: any) {
      showToast(error.message, 'error');
      setSubmitting(false);
    }
  };
  const validationSchema = Yup.object({
    name: Yup.string().required('Name is required'),
    description: Yup.string().required('Description is required'),
    client: Yup.string().required('Select a Client'),
    default: Yup.boolean().default(false),
    processes: Yup.boolean().default(false)
  });

  return (
    initialValues && (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          onTeamFormSubmit(values, setSubmitting);
        }}
        enableReinitialize>
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          setFieldError,
          setFieldTouched,
          validateField
        }) => (
          <form onSubmit={handleSubmit}>
            <MainCard
              sx={{
                bgcolor: 'transparent',
                border: 0,
                margin: 0,
                padding: 0,
                width: '100%'
              }}
            >
              <CardContent sx={{ padding: 0, margin: 0 }}>
                {/* Distinct heading for create/update */}
                <Box sx={{ mb: 3 }}>
                  {teamUid ? (
                    <h2 style={{ fontWeight: 700, fontSize: 22, margin: 0 }}>Update Team</h2>
                  ) : (
                    <h2 style={{ fontWeight: 700, fontSize: 22, margin: 0 }}>Create New Team</h2>
                  )}
                </Box>
                <Box sx={{ py: 0, pr: 2, width: '100%', height: '100%' }}>
                  <Grid container sx={{ width: '100%' }} rowGap={3}>
                    <SGrid item xs={3} sx={{justifyContent:"flex-start"}}>
                    <label 
                      htmlFor="client" 
                      style={{ 
                        fontWeight: 500,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent:"flex-start",
                        height: '100%' 
                      }}
                    >
                      Client:
                    </label>
                  </SGrid>
                  <Grid 
                    item 
                    xs={9}
                    sx={{
                      pl: 1 
                    }}
                  >
                    <Select
                      id="client"
                      name="client"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      size="small"
                      placeholder="Enter Client Name"
                      error={touched.client && errors.client ? true : false}
                      defaultValue={values?.client}
                      disabled={teamUid && values?.client}
                      endAdornment={
                        touched.client &&
                        errors.client && (
                          <InputAdornment position="end">
                            <ErrorTooltip title={errors.client} open={touched.client && errors.client ? true : false}>
                              <InfoCircle size="14px" color={theme.palette.error.main} />
                            </ErrorTooltip>
                          </InputAdornment>
                        )
                      }
                    >
                      {availableClients.map((client) => (
                        <MenuItem key={client?.uid} value={client?.uid}>
                          {client?.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                    <SGrid item xs={3} sx={{justifyContent:"flex-start"}}>
                      <label htmlFor="name" style={{ fontWeight: 500 }}>Process Name:</label>
                    </SGrid>
                    <Grid item xs={9}>
                      <OutlinedInput
                        id="name"
                        name="name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        size="small"
                        placeholder="Enter Process Name"
                        error={touched.name && errors.name ? true : false}
                        defaultValue={values?.name}
                        readOnly={!hasEditPermission}
                        sx={{
                          ...(!hasEditPermission && {
                            '& .MuiOutlinedInput-input': {
                              backgroundColor: 'grey.100',
                              cursor: 'not-allowed'
                            }
                          })
                        }}
                        endAdornment={
                          touched.name &&
                          errors.name && (
                            <InputAdornment position="end">
                              <ErrorTooltip title={errors.name} open={touched.name && errors.name ? true : false}>
                                <InfoCircle size="14px" color={theme.palette.error.main} />
                              </ErrorTooltip>
                            </InputAdornment>
                          )
                        }
                      />
                    </Grid>

                    <Grid item xs={3} display={'flex'} justifyContent={'flex-start'} alignItems={'center'}>
                      <label htmlFor="description" style={{ fontWeight: 500 }}>Description:</label>
                    </Grid>
                    <Grid item xs={9}>
                      <OutlinedInput
                        id="description"
                        name="description"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        multiline
                        minRows={3}
                        size="small"
                        placeholder="Enter Details about the Process"
                        error={touched.description && errors.description ? true : false}
                        defaultValue={values?.description}
                        endAdornment={
                          touched.description &&
                          errors.description && (
                            <InputAdornment position="end">
                              <ErrorTooltip title={errors.description} open={touched.description && errors.description ? true : false}>
                                <InfoCircle size="14px" color={theme.palette.error.main} />
                              </ErrorTooltip>
                            </InputAdornment>
                          )
                        }
                      />
                    </Grid>

                    {/* {teamUid && (
                      <Grid item xs={3} display={'flex'} justifyContent={'end'} alignItems={'center'}>
                        <label htmlFor="default" style={{ fontWeight: 500 }}>Default Process:</label>
                      </Grid>
                    )} */}

                    
                    
                      {teamUid && (
                        <Grid item xs={12}>
                          <Box sx={{ mt: 2, mb: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 2, background: '#f5f7fa' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>  
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                              <Tooltip title="Drivers, VADs crew or any field agents who do not have access to the app can use this link to upload transactions to this team" placement="top" arrow>
                                <span style={{marginRight:"8px"}}>
                                  <InfoCircle size="20px" color={theme.palette.primary.main} style={{ marginLeft: 8, cursor: 'pointer' }} />
                                </span>
                              </Tooltip>
                              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: theme.palette.text.primary,mr:1 }}>
                                Team Weblink
                              </Typography>
                            </Box>
                              <Box sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: 1,
                                p: 1.5,
                                bgcolor: theme.palette.grey[50],
                                border: `1px solid ${theme.palette.grey[200]}`,
                                borderRadius: 1,
                                cursor: 'pointer',
                                '&:hover': {
                                  bgcolor: theme.palette.grey[100]
                                }
                              }}
                              onClick={() => window.open(getWeblinkUrl(), '_blank')}
                              >
                                <Typography 
                                  variant="body2" 
                                  sx={{ 
                                    fontFamily: 'monospace',
                                    fontSize: '0.85rem',
                                    color: theme.palette.text.secondary,
                                    flex: 1,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                  }}
                                >
                                  {getWeblinkUrl()}
                                </Typography>
                                <IconButton
                                  size="small"
                                  aria-label="Copy link"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation(); // Prevent parent click handler
                                    navigator.clipboard.writeText(getWeblinkUrl()).then(() => {
                                      if (typeof showToast === 'function') {
                                        showToast('Link copied to clipboard', 'success');
                                      }
                                    }).catch(() => {
                                      if (typeof showToast === 'function') {
                                        showToast('Failed to copy link', 'error');
                                      }
                                    });
                                  }}
                                  sx={{ 
                                    ml: 0.5,
                                    '&:hover': {
                                      bgcolor: theme.palette.primary.light,
                                      '& svg': {
                                        stroke: theme.palette.primary.contrastText
                                      }
                                    }
                                  }}
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={theme.palette.grey[600]} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                    <path d="M5 15V5a2 2 0 0 1 2-2h10"></path>
                                  </svg>
                                </IconButton>
                              </Box>
                              </Box>
                              <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mt: 0.5, display: 'block' }}>
                                Click to open link or copy to clipboard
                              </Typography>
                            </Box>
                          
                        </Grid>
                      )}
                    {/* Settings Fields */}
                    <Typography variant="h4" sx={{fontWeight: 700}}>Process Settings</Typography>
                    <Grid item xs={12}>
                      <Box sx={{ p: 2, border: '1px solid #eee', borderRadius: 2, bgcolor: '#fafafa' }}>
                        <Grid container spacing={2.6}>
                          <Grid item xs={12} sm={6}>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={values.settings?.addTransaction}
                                  onChange={e => setFieldValue('settings.addTransaction', e.target.checked)}
                                  sx={{
                            '& .MuiSwitch-track': {
                              backgroundColor: values.settings?.addTransaction ? theme.palette.secondary.dark : theme.palette.grey[400],
                            },
                            '& .Mui-checked + .MuiSwitch-track': {
                              backgroundColor: theme.palette.secondary.dark,
                            },
                          }}
                                />
                              }
                              label={<label htmlFor="settings.addTransaction" style={{ fontWeight: 500,fontSize:"12px" }}>Allow the Process to Create/Add Transaction</label>}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={values.settings?.addTransactionAtDriver}
                                  onChange={e => setFieldValue('settings.addTransactionAtDriver', e.target.checked)}
                                 sx={{
                            '& .MuiSwitch-track': {
                              backgroundColor: values.settings?.addTransactionAtDriver ? theme.palette.secondary.dark : theme.palette.grey[400],
                            },
                            '& .Mui-checked + .MuiSwitch-track': {
                              backgroundColor: theme.palette.secondary.dark,
                            },
                          }}
                                />
                              }
                              label={<label htmlFor="settings.addTransactionAtDriver" style={{ fontWeight: 500,fontSize:"12px" }}>Allow the Weblink user to Create/Add Transaction</label>}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={values.settings?.allowThirdPartyTransaction}
                                  onChange={e => setFieldValue('settings.allowThirdPartyTransaction', e.target.checked)}
                                  sx={{
                                    '& .MuiSwitch-track': {
                                      backgroundColor: values.settings?.allowThirdPartyTransaction ? theme.palette.secondary.dark : theme.palette.grey[400],
                                    },
                                    '& .Mui-checked + .MuiSwitch-track': {
                                      backgroundColor: theme.palette.secondary.dark,
                                    },
                                  }}
                                />
                              }
                              label={<label htmlFor="settings.allowThirdPartyTransaction" style={{ fontWeight: 500,fontSize:"12px" }}>Allow the third party user to access the process</label>}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={values?.settings?.isMfaEnabled}
                                  onChange={e => setFieldValue('settings.isMfaEnabled', e.target.checked)}
                                  sx={{
                            '& .MuiSwitch-track': {
                              backgroundColor: values?.settings?.isMfaEnabled ? theme.palette.secondary.dark : theme.palette.grey[400],
                            },
                            '& .Mui-checked + .MuiSwitch-track': {
                              backgroundColor: theme.palette.secondary.dark,
                            },
                          }}
                                />
                              }
                              label={<label htmlFor="settings.isMfaEnabled" style={{ fontWeight: 500,fontSize:"12px" }}>Enable 2-Step Verification through Unique Code</label>}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <label htmlFor="settings.transactionLabel" style={{ fontWeight: 500, marginBottom: 4, display: 'block' }}>Label For Transaction Field</label>
                            <OutlinedInput
                              id="settings.transactionLabel"
                              name="settings.transactionLabel"
                              value={values.settings?.transactionLabel}
                              onChange={handleChange}
                              fullWidth
                              size="small"
                              placeholder="Transaction Label"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <label htmlFor="settings.startDateLabel" style={{ fontWeight: 500, marginBottom: 4, display: 'block' }}>Label For the Start Date field</label>
                            <OutlinedInput
                              id="settings.startDateLabel"
                              name="settings.startDateLabel"
                              value={values.settings?.startDateLabel}
                              onChange={handleChange}
                              fullWidth
                              size="small"
                              placeholder="Start Date Label"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <label htmlFor="settings.dueDateLabel" style={{ fontWeight: 500, marginBottom: 4, display: 'block' }}>Label For the Due Date field</label>
                            <OutlinedInput
                              id="settings.dueDateLabel"
                              name="settings.dueDateLabel"
                              value={values.settings?.dueDateLabel}
                              onChange={handleChange}
                              fullWidth
                              size="small"
                              placeholder="Due Date Label"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <label htmlFor="settings.mfaKey" style={{ fontWeight: 500, marginBottom: 4, display: 'block' }}>MFA Key:</label>
                            <OutlinedInput
                              id="settings.mfaKey"
                              name="settings.mfaKey"
                              value={values.settings?.mfaKey}
                              onChange={handleChange}
                              fullWidth
                              size="small"
                              placeholder="MFA Key (optional)"
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>

{teamUid && (
  <Grid item xs={12} mt={2}>
    <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
        Transaction List Config
      </Typography>
    <Box sx={{ p: 2, border: '1px solid #e0e0e0', borderRadius: 2, bgcolor: '#f5f7fa' }}>
      
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={3} display="flex" justifyContent="start">
          <label htmlFor="transactionFieldSelect" style={{ fontWeight: 500, marginTop: "5px" }}>
            Select Fields:
          </label>
        </Grid>
        <Grid item xs={9}>
          <FormControl fullWidth size="small">
            <InputLabel id="transactionFieldSelect-label">
              Select atmost 5 fields to be displayed in the transaction fields
            </InputLabel>
             <Select
      labelId="transactionFieldSelect-label"
      id="transactionFieldSelect"
      name="transactionFieldSelect"
      multiple
      value={[
        ...(values.reportingStatus ? ['reportingStatus'] : []),
        ...(values.displayStepStatus ? ['displayStepStatus'] : []),
        ...(values.process ? ['process'] : []),
        ...Array.isArray(values.transactionFieldSelect) ? values.transactionFieldSelect : []
      ]}
      label="Field Name"
      onChange={(e) => {
        const selectedValues = e.target.value as string[];


        // Handle system fields
        setFieldValue('reportingStatus', selectedValues.includes('reportingStatus'));
        setFieldValue('displayStepStatus', selectedValues.includes('displayStepStatus'));
        setFieldValue('process', selectedValues.includes('process'));

        // Handle regular fields
        const regularFields = selectedValues.filter(value => 
          !['reportingStatus', 'displayStepStatus', 'process'].includes(value)
        );

        // Check if the selection is within the limit of 5
        if (selectedValues.length <= 5) {
          setFieldValue('transactionFieldSelect', regularFields);
        } else {
          showToast('You can select maximum 5 fields', 'warning');
        }
      }}
      renderValue={(selected) => {
        if (!selected || selected.length === 0) return "";

        return (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((sel: string) => {
              // Handle system fields
              if (['reportingStatus', 'displayStepStatus', 'process'].includes(sel)) {
                const labelMap: { [key: string]: string } = {
                  reportingStatus: 'Status',
                  displayStepStatus: 'Activity Status',
                  process: 'Processes'
                };
                return (
                  <Box
                    key={sel}
                    onMouseDown={(e) => e.stopPropagation()}
                  >
                    <Chip
                      key={sel}
                      label={labelMap[sel]}
                      size="small"
                      onDelete={(event) => {
                        event.stopPropagation();
                        setFieldValue(sel, false);
                      }}
                      sx={{
                        backgroundColor: theme.palette.secondary.light,
                        color: theme.palette.secondary.dark,
                        "& .MuiChip-deleteIcon": {
                          color: theme.palette.secondary.dark,
                          "&:hover": {
                            color: theme.palette.secondary.main,
                          },
                        },
                      }}
                    />
                  </Box>
                );
              }

              // Handle regular fields
              let parsed;
              try {
                parsed = JSON.parse(sel);
              } catch {
                parsed = { question: sel };
              }
              return (
                <Box
                  key={parsed.uid}
                  onMouseDown={(e) => e.stopPropagation()}
                >
                  <Chip
                    key={parsed.uid}
                    label={parsed.question}
                    size="small"
                    onDelete={(event) => {
                      event.stopPropagation();
                      const updatedSelection =
                        values.transactionFieldSelect.filter(
                          (item: string) => item !== sel
                        );
                      setFieldValue("transactionFieldSelect", updatedSelection);
                    }}
                  sx={{
                    backgroundColor: theme.palette.secondary.light,
                    color: theme.palette.secondary.dark,
                    "& .MuiChip-deleteIcon": {
                      color: theme.palette.secondary.dark,
                      "&:hover": {
                        color: theme.palette.secondary.main,
                      },
                    },
                  }}
                />
                </Box>
              );
            })}
          </Box>
          
        );
      }}
    >
      {/* System Fields */}
      <MenuItem disabled divider>
        <strong>Default Fields</strong>
      </MenuItem>
      <MenuItem value="reportingStatus">
        Status
      </MenuItem>
      <MenuItem value="displayStepStatus">
        Activity Status
      </MenuItem>
      <MenuItem value="process">
        Processes
      </MenuItem>
      
      {/* Process Fields */}
      {Array.isArray(processFields) &&
        processFields.map((step, idx2) => {
          const allFields = step.component?.fields || [];
          if (allFields.length === 0) return null;

          return [
            <MenuItem key={step.title + idx2} disabled divider>
              <strong>{step.title}</strong>
            </MenuItem>,
            ...allFields.map((field: any) => (
              <MenuItem
                key={field._id}
                value={JSON.stringify({
                  question: field.question,
                  uid: field.uid,
                })}
              >
                {field.question}
              </MenuItem>
            )),
          ];
        })}
    </Select>

          </FormControl>
        </Grid>
        {/* Removed separate checkboxes as they are now part of the dropdown */}
                  </Grid>
                </Box>
              </Grid>
           )}
                  </Grid>
                </Box>
              </CardContent>
              <CardActions sx={{ borderTop: '1px solid rgba(219, 224, 229, 0.65)', justifyContent: 'end', pt: 2, pb: 0, mt: 3 }}>
                <Button
                  disabled={isSubmitting}
                  color="error"
                  type="button"
                  onClick={() => {
                    resetForm();
                  }}
                >
                  Cancel
                </Button>
                <PermissionWrapper permission={PERMISSIONS.ADD_EDIT_PROCESS} disableInsteadOfHide={true}>
                  <Button
                    disabled={isSubmitting || !hasEditPermission}
                    variant="contained"
                    type="submit"
                    sx={{
                      transition: 'all 0.5s ease-out',
                      color: 'text.main',
                      bgcolor: 'secondary.dark',
                      '&:hover': {
                        bgcolor: 'secondary.main'
                      }
                    }}
                    startIcon={isSubmitting && <CircularProgress color="primary" size="sm" />}
                  >
                    Save
                  </Button>
                </PermissionWrapper>
              </CardActions>
            </MainCard>
          </form>
        )}
      </Formik>
    )
  );
};

export default TeamForm;
